import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";

import { createLocality } from "../../../actions/nameAction_Ggn";

import {  Form, Button } from "semantic-ui-react";
import TextInput from "../../form/TextInput";

class LocalityCreate extends Component {
  onSubmit = (values) => {
    this.props.createLocality(values);
  };

  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;

    return (
      <div
        className="font-family-Roboto"
        style={{ maxWidth: "700px", margin: "auto" }}
      >
        {/**/}
        <div
          className="card-attached border-radius-top "
          style={{ textAlign: "center", backgroundColor: "skyblue" }}
        >
          <div
            style={{
              fontSize: "1.3rem",
              fontWeight: "bold",
              padding: "10px",
            }}
          >
            {/*  */}
            Create Locality
            {/*  */}
          </div>
        </div>
        {/**/}

        {/*  */}

        <div className="card-attached border-radius-bottom pxy-20">
          <div className=" label">
            <Form onSubmit={handleSubmit(this.onSubmit)}>
              <label>Locality</label>
              <Field
                name="locality"
                type="text"
                component={TextInput}
                placeholder="Locality"
              />

              <br />

              <Button
                color="olive"
                type="submit"
                disabled={pristine || submitting}
              >
                Submit
              </Button>
              <Button
                color="orange"
                type="button"
                disabled={pristine || submitting}
                onClick={reset}
              >
                Clear Values
              </Button>
              <Button
                color="teal"
                type="button"
                onClick={() => this.props.closeModal()}
              >
                Cancel
              </Button>
            </Form>
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    state,
    userA: state.auth.userA,
  };
};
export default connect(mapStateToProps, { createLocality })(
  reduxForm({
    form: "LocalityCreate", // a unique identifier for this form
    // validate
  })(LocalityCreate)
);
